<template>
  <div
    :class="row.class"
    class="flex flex-row items-center justify-around md:justify-center flex-wrap md:flex-no-wrap"
  >
    <div
      v-for="logo in row.logos"
      :key="logo.name"
      :class="row.class + '__item'"
      class="content__lien-utile flex flex-col items-center justify-around"
    >
      <h3>{{ logo.name }}</h3>

      <div v-if="logo.svg" class="lien-utile__logo">
        <img :class="row.class + '__logo--svg'" :src="logo.path" />
      </div>
      <div v-else class="lien-utile__logo">
        <img :class="row.class + '__logo'" :src="logo.path" />
      </div>

      <a target="_blank" :href="logo.link">Visiter le site</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['row']
}
</script>

<style lang="css" scoped>
h3 {
  font-size: 1.1vw;
  font-style: italic;
}

a {
  font-size: 1.1vw;
  text-decoration: underline;
}

[class$="__logo"] {
  max-height: 3vw;
  padding: 0 0.5vw;
}

[class$="__logo--svg"] {
  height: 3vw;
}

.content__lien-utile {
  flex-basis: 15%;
  height: 10vw;
  background: #ffffff;
  border-radius: 15px;
  padding: 0;
}

.content__lien-utile:not(:first-child) {
  margin-left: 2.5vw;
}

.top-row,
.top-mid-row,
.bot-mid-row {
  margin-bottom: 4vw;
}

.top-row .content__lien-utile {
  border: 2px inset #990d44;
}

.top-mid-row .content__lien-utile {
  border: 2px inset #f7c66a;
}

.bot-mid-row .content__lien-utile {
  border: 2px inset #5db99d;
}

.bot-row .content__lien-utile {
  border: 2px inset #52cfeb;
}

@media screen and (max-width: 768px) {
  h3,
  a {
    font-size: 4.5vw;
  }
  .content__lien-utile {
    flex-basis: 45%;
    height: 40vw;
    margin: 4.5vw 0 !important;
  }
  [class$="__logo"] {
    max-height: 10vw;
  }

  [class$="__logo--svg"] {
    height: 10vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lienUtile.vue